import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { useRole } from "../hooks/useRole";
import Loader from "../components/Loader";
import { sidebarItems } from "../pages/admin/Navbars/SidebarData";


SuperAdminGuard.propTypes = {
  children: PropTypes.node,
  requiredPermission: PropTypes.string,
};

export default function SuperAdminGuard({ children, requiredPermission }) {
  const { token } = useAuth();
  const { user, role } = useRole();
  const [authorized, setAuthorized] = useState(null);

  useEffect(() => {
    if (!token) {
      setAuthorized(false);
      return;
    }

    const checkAuth = () => {
      if (role === "super_admin") {
        setAuthorized(true);
        return;
      }
      if (requiredPermission && user?.permissions) {
        if (user.permissions.includes(requiredPermission)) {
          setAuthorized(true);
          return;
        }
      }
      if (!requiredPermission && role === "super_admin") {
        setAuthorized(true);
        return;
      }

      setAuthorized(false);
    };
    const timer = setTimeout(() => {
      checkAuth();
    }, 50);

    return () => clearTimeout(timer);
  }, [token, role, user, requiredPermission]);
  if (authorized === null) return <Loader />;
  if (!token) {
    return <Navigate to="/login" />;
  }

  if (!authorized) {
    const permissions = user.permissions || [];

    const path = sidebarItems.find((item) => item.module === permissions[0]);

    return <Navigate to={path?.url ?? "/"} />;
  }
  return <>{children}</>;
}
